import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useStockStore from '../../stores/useStockStore'; // ✅ import store

import BrokerStatus from '../dashboard/components/BrokerStatus';
import LoginFormSch from './components/LoginFormSch';
import TermsConditionsSch from './components/TermsConditionsSch';
import ConsentModalSch from './components/ConsentModalSch';
import AccountSelectionSch from './components/AccountSelectionSch';
import ReviewSelectionSch from './components/ReviewSelectionSch';

export default function MainPageSch() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [showConsent, setShowConsent] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const { forceConnect } = useStockStore(); // ✅ ดึงมาจาก store

  return (
    <div className="min-h-screen bg-white p-4 max-w-4xl mx-auto">
      {step === 1 && <LoginFormSch onNext={() => setStep(2)} />}

      {step === 2 && (
        <div style={{ padding: 20 }}>
          <TermsConditionsSch onAccept={() => setShowConsent(true)} />
          {showConsent && (
            <ConsentModalSch
              onCancel={() => setShowConsent(false)}
              onAccept={() => {
                setShowConsent(false);
                setStep(3);
              }}
            />
          )}
        </div>
      )}

      {step === 3 && (
        <AccountSelectionSch
          selectedAccounts={selectedAccounts}
          setSelectedAccounts={setSelectedAccounts}
          onNext={() => setStep(4)}
          onBack={() => setStep(2)}
        />
      )}

      {step === 4 && (
        <ReviewSelectionSch
          selectedAccounts={selectedAccounts}
          onDone={() => {
            forceConnect(); // ✅ บอกว่าเชื่อมต่อแล้ว
            setStep(5);
          }}
          onBack={() => setStep(3)}
        />
      )}

      {step === 5 && <BrokerStatus />}
    </div>
  );
}
